// Categorize announcement to time range group
const announcementGroupsReadonly = ["today", "yesterday", "this week", "this month", "all time"] as const;

export type AnnouncementGroup = (typeof announcementGroupsReadonly)[number];

export const announcementGroups = [...announcementGroupsReadonly];

const startOfDay = (date: Date): Date => {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  return d;
};

const startOfWeek = (date: Date): Date => {
  const d = startOfDay(date);
  const day = d.getDay();
  const diff = d.getDate() - day;
  d.setDate(diff);
  return d;
};

const startOfMonth = (date: Date): Date => {
  const d = startOfDay(date);
  d.setDate(1);
  return d;
};

const today = startOfDay(new Date());
const todayTime = today.getTime();

const yesterday = startOfDay(new Date());
yesterday.setDate(yesterday.getDate() - 1);
const yesterdayTime = yesterday.getTime();

export const getGroupFromCreatedDate = (date: number): (typeof announcementGroupsReadonly)[number] => {
  const createdDate = new Date(date);
  const createdDateTime = createdDate.getTime();

  const startOfWeekTime = startOfWeek(new Date()).getTime();
  const startOfMonthTime = startOfMonth(new Date()).getTime();

  if (createdDateTime >= todayTime) {
    return "today";
  }

  if (createdDateTime >= yesterdayTime) {
    return "yesterday";
  }

  if (createdDateTime >= startOfWeekTime) {
    return "this week";
  }

  if (createdDateTime >= startOfMonthTime) {
    return "this month";
  }
  return "all time";
};
